module.exports = __webpack_public_path__ + "img/resource2.06e77528.jpg";